import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import {useTranslation} from "react-i18next";
import {disableLoading, enableLoading} from "../../../../features/loading/loadingSlice";
import React, {useState, useEffect} from "react";
import {useDispatch} from "react-redux";
import GetNuke from '../../../../queries/Devices/GetNuke';
import moment from 'moment';
import LightPost from "../../../LightPost/LightPost";


export default function NukeModal(props) {
    const {t} = useTranslation();
    const dispatch = useDispatch();

    const [messages, setMessages] = useState([]);

    useEffect(() => {
        
        if(props.selectedDevice) {
            updateData(props.selectedDevice.id);
        }
    }, [props.selectedDevice])


    useEffect(() => {
        if(!props.selectedDevice) {
            return;
        }
        
    }, [props.selectedDevice]);

    const cleanAndCloseModal = () => {
      
        
        props.hideFn();
    }


    const updateData = (id) => {
        dispatch(enableLoading());
         GetNuke(id).then((result) => {
            console.log(result.data.data.messages);
            setMessages(result.data.data.messages || []);
         }).finally(() => {
            dispatch(disableLoading());
         });
        
    };

    
    
    return (<Modal {...props} size="lg">
        <Modal.Header>
            {props.selectedDevice && <Modal.Title>{props.selectedDevice.name}</Modal.Title> }
        </Modal.Header>
        <Modal.Body>
            <table className="table table-responsive">
                <tr>
                    <th>{t("Date")}</th>
                    <th>{t("Error")}</th>
                </tr>
                
                {messages.map((messageObject, index) => {
                    
                    const [date, error] = Object.entries(messageObject)[0];
                    
                    return (
                        <tr key={`${date}-${index}`}>
                            <td>{date}</td>
                            <td>{error}</td>
                        </tr>
                    );
                })}
            </table>
      

        </Modal.Body>
        <Modal.Footer>
            <Button variant="secondary" onClick={() => cleanAndCloseModal()}>
                {t("Close")}
            </Button>
    
        </Modal.Footer>
    </Modal>);
}
